import { subDays } from 'date-fns';
import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterDocumentDateCustomTypes,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';
import { Timestamp } from 'shared/types/timestamp';

// Limit completed tasks to a recent window so we don't fetch the entire
// task history from Firestore on each visit.
export const COMPLETED_LOOKBACK_DAYS = 14;

export const createDefaultFilter = (today: Timestamp): FilterDocument => ({
  [DocumentOrganizationKeys.GroupByMode]: GroupByMode.CompletedDate,
  [DocumentOrganizationKeys.SortingMode]: SortingMode.Custom,
  showCompleted: true,
  [DocumentOrganizationKeys.Filters]: {
    [FilterOptionKeys.Date]: {
      type: FilterDocumentDateFilterTypes.Custom,
      custom: {
        type: FilterDocumentDateCustomTypes.After,
        start: subDays(today, COMPLETED_LOOKBACK_DAYS),
        end: null,
      },
    },
  },
});
